import React, { useState } from "react";
import apiRoutes from "../../../api/apiRoutes";
import { appFetchJson } from "../../../utils/http";

export default function EliminarProductoContrato({
  registro = {},
  onClose = () => {},
  onDeleted = () => {},
}) {
  const [loading, setLoading] = useState(false);

  // Formatear números con separadores de miles
  const formatNumber = (val) => {
    if (val === null || val === undefined) return "—";
    return Number(val).toLocaleString("es-PY");
  };

  const handleDelete = async () => {
    setLoading(true);
    try {
      const id = registro.id;
      if (!id) throw new Error("ID de detalle no encontrado.");
      const url = apiRoutes.contratoDetalle.eliminarUrl(id);
      await appFetchJson(url, { method: "DELETE" });
      onDeleted();
      onClose();
    } catch (e) {
      console.error("Error al eliminar el producto del contrato:", e);
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="w-full">
      <div className="px-6 py-4 border-b">
        <h2 className="section-title">Eliminar Producto del Contrato</h2>
      </div>

      <div className="px-6 pt-4">
        <div className="mb-4 px-4 py-3 text-sm text-blue-600">
          ¿Está seguro que desea eliminar este producto del contrato?
        </div>

        {/* Resumen de datos a eliminar */}
        <div className="bg-gray-50 px-6 py-6 mb-2 space-y-2">
          <div>
            <span className="text-gray-500 mr-1">Contrato:</span>
            <span className="font-medium">{registro.contratoCodigo ?? "—"}</span>
          </div>
          <div>
            <span className="text-gray-500 mr-1">Producto:</span>
            <span className="font-medium">{registro.productoNombre ?? "—"}</span>
          </div>
          <div>
            <span className="text-gray-500 mr-1">Cantidad de Producto:</span>
            <span className="font-medium">{formatNumber(registro.qnProducto)}</span>
          </div>
          <div>
            <span className="text-gray-500 mr-1">Valor de Descuento Producto:</span>
            <span className="font-medium">{formatNumber(registro.valorMontoDescuento)}</span>
          </div>
          <div>
            <span className="text-gray-500 mr-1">Valor de Monto PYG:</span>
            <span className="font-medium">{formatNumber(registro.valorMonto)}</span>
          </div>
          <div>
            <span className="text-gray-500 mr-1">Cantidad Producto Utilizado:</span>
            <span className="font-medium">{formatNumber(registro.qnUtilizado)}</span>
          </div>
          <div>
            <span className="text-gray-500 mr-1">Valor de Monto PYG Utilizado:</span>
            <span className="font-medium">{formatNumber(registro.valorMontoUtilizado)}</span>
          </div>
        </div>
      </div>

      <div className="px-6 py-4 border-t flex gap-2 modal-footer">
        <button className="btn-fil" onClick={handleDelete} disabled={loading}>
          {loading ? "Eliminando…" : "Eliminar"}
        </button>
        <button className="btn-fil" onClick={onClose}>
          Cancelar
        </button>
      </div>
    </div>
  );
}